import {UserException} from '@/domain/user/exception/UserException'

export class CannotRestoreUserException extends UserException {

}

